import BackboneElement from './BackboneElement';
import merge from 'lodash/merge';

export default class BN_TreatmentPlanObjectiveIntervention extends BackboneElement {
    static __className = 'BN_TreatmentPlanObjectiveIntervention';

    __objectStructure = {
        display: String, // Free-text human name; `id` is inherited from BackboneElement
    };

    constructor(constructJson, className = 'BN_TreatmentPlanObjectiveIntervention') {
        super(constructJson, className);
        this.createAndPopulateStructure(this.__objectStructure, constructJson);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
